// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz

(() => {
  const rotAv = (nod) => nod.closest('[data-component="aterkallelse"]');

  const falt = (rot, namn) => rot.querySelector(`[data-falt="${namn}"]`);

  const synkaRad = (el) => {
    const rad = el.closest('.aterkallelse__rad');
    if (!(rad instanceof HTMLElement)) return;
    const varde = 'value' in el ? String(el.value).trim() : '';
    rad.dataset.tillstand = varde ? 'fylld' : 'tom';
  };

  const kravFalt = (rot) => ['namn', 'epost', 'order'].map((namn) => falt(rot, namn));

  const validera = (rot) => {
    const fält = kravFalt(rot);
    let giltig = true;

    fält.forEach((el) => {
      if (!(el instanceof HTMLInputElement)) return;
      el.setCustomValidity('');
      if (!el.value.trim()) {
        el.setCustomValidity(rot.dataset.krav || 'This field is required.');
      }
      const ok = el.checkValidity();
      if (!ok) giltig = false;
      const rad = el.closest('.aterkallelse__rad');
      if (rad instanceof HTMLElement) {
        rad.dataset.tillstand = el.value.trim() ? 'fylld' : 'tom';
        if (!ok) rad.dataset.fel = 'ja';
        else delete rad.dataset.fel;
      }
    });

    const fel = rot.querySelector('[data-fel]');
    if (fel instanceof HTMLElement) fel.hidden = giltig;
    return giltig;
  };

  const rensaFel = (rot) => {
    const fält = kravFalt(rot);
    const redo = fält.every((el) => el instanceof HTMLInputElement && el.value.trim() && el.checkValidity());
    if (!redo) return;
    const fel = rot.querySelector('[data-fel]');
    if (fel instanceof HTMLElement) fel.hidden = true;
    fält.forEach((el) => {
      const rad = el.closest('.aterkallelse__rad');
      if (rad instanceof HTMLElement) delete rad.dataset.fel;
    });
  };

  const visaBekraftelse = (rot) => {
    if (!validera(rot)) return;
    falt(rot, 'sammanfattning-namn').textContent = falt(rot, 'namn').value.trim();
    falt(rot, 'sammanfattning-epost').textContent = falt(rot, 'epost').value.trim();
    falt(rot, 'sammanfattning-order').textContent = falt(rot, 'order').value.trim();
    rot.dataset.step = 'bekrafta';
  };

  const visaFormular = (rot) => {
    rot.dataset.step = 'fyll';
  };

  const skrivKropp = (rot) => {
    const detaljer = falt(rot, 'detaljer') instanceof HTMLTextAreaElement
      ? falt(rot, 'detaljer').value.trim()
      : '';
    const rader = [
      'WITHDRAWAL NOTICE',
      `Name: ${falt(rot, 'namn').value.trim()}`,
      `Email: ${falt(rot, 'epost').value.trim()}`,
      `Order number: ${falt(rot, 'order').value.trim()}`,
    ];
    if (detaljer) rader.push(`Details: ${detaljer}`);
    falt(rot, 'kropp').value = rader.join('\n');
    const amne = falt(rot, 'amne');
    const order = falt(rot, 'order').value.trim();
    if (amne instanceof HTMLInputElement) {
      const bas = amne.getAttribute('value') || 'Withdrawal notice';
      amne.value = order ? `${bas} — ${order}` : bas;
    }
  };

  document.addEventListener('input', (handelse) => {
    const el = handelse.target;
    if (!(el instanceof HTMLInputElement) && !(el instanceof HTMLTextAreaElement)) return;
    const rot = rotAv(el);
    if (!rot) return;
    synkaRad(el);
    rensaFel(rot);
  });

  document.addEventListener('click', (handelse) => {
    const bekrafta = handelse.target.closest('[data-action~="aterkallelse/bekrafta"]');
    if (bekrafta) {
      const rot = rotAv(bekrafta);
      if (!rot) return;
      handelse.preventDefault();
      visaBekraftelse(rot);
      return;
    }

    const tillbaka = handelse.target.closest('[data-action~="aterkallelse/tillbaka"]');
    if (tillbaka) {
      const rot = rotAv(tillbaka);
      if (!rot) return;
      handelse.preventDefault();
      visaFormular(rot);
    }
  });

  document.addEventListener('submit', (handelse) => {
    const rot = handelse.target.querySelector?.('[data-component="aterkallelse"]');
    if (!(rot instanceof HTMLElement)) return;
    if (rot.dataset.step !== 'bekrafta') {
      handelse.preventDefault();
      visaBekraftelse(rot);
      return;
    }
    skrivKropp(rot);
  });
})();
